import { COLOR, mq } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";
import { GLOBAL_NAVI_HEIGHT } from "~/styles/layout";
import { Z_INDEX } from "~/styles/z-index";

export const fixedOnTop = `
position: sticky;
top: 0;
z-index: ${Z_INDEX.HEADER};
`;

export const HeaderWrapper = styled.header<{ isShowSearch?: boolean }>`
  ${fixedOnTop}
  height: ${GLOBAL_NAVI_HEIGHT.PC}px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${COLOR.GRAY100.code};
  border-bottom: 1px solid ${COLOR.GRAY200.code};

  ${mq.sp} {
    height: ${GLOBAL_NAVI_HEIGHT.SP}px;
  }

  ${({ isShowSearch }) =>
    isShowSearch &&
    `
      ${mq.tablet} {
        border-bottom: none;
      }
    `}
`;

export const DivBackDrop = styled.div`
  width: 100%;
  height: 100vh;
  height: calc(var(--1dvh, 1vh) * 100);
  height: 100dvh;
  background-color: rgba(${COLOR.GRAY100.rgb}, 0.6);
  position: fixed;
  top: ${GLOBAL_NAVI_HEIGHT.PC}px;
  left: 0;
  z-index: ${Z_INDEX.BACK_DROP};
  display: flex;
  justify-content: flex-end;
  overflow-y: hidden;
  ${mq.sp} {
    top: ${GLOBAL_NAVI_HEIGHT.SP}px;
  }
`;
